import type { ReactElement } from 'react'

/**
 * Iconos locales del VistaToggle.
 *
 * No existe un icono de "filas / cuadrícula" en el registro del DS
 * (`atoms/Icons`), por lo que se mantienen como SVG inline pequeños y
 * decorativos. El color lo aporta el contenedor vía `currentColor` y, al ser
 * decorativos (el significado lo da el `aria-label` del botón), van marcados
 * con `aria-hidden`.
 */

const SIZE = 16
const VIEW_BOX = '0 0 16 16'

/** Dos filas apiladas: vista en lista (cards horizontales, una por fila). */
export function IconRows(): ReactElement {
  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={VIEW_BOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0.5" y="1.5" width="15" height="5" stroke="currentColor" />
      <rect x="0.5" y="9.5" width="15" height="5" stroke="currentColor" />
    </svg>
  )
}

/** Cuadrícula 2x2: vista en cuadrícula (cards verticales, varias columnas). */
export function IconGrid(): ReactElement {
  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={VIEW_BOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0.5" y="0.5" width="6" height="6" stroke="currentColor" />
      <rect x="9.5" y="0.5" width="6" height="6" stroke="currentColor" />
      <rect x="0.5" y="9.5" width="6" height="6" stroke="currentColor" />
      <rect x="9.5" y="9.5" width="6" height="6" stroke="currentColor" />
    </svg>
  )
}
